<template>
  <section class="pdf-add-wrapper">
    <b-row
      class="pdf-add-row"
      v-for="(page, pageIndex) in pages"
      :key="'page' + pageIndex"
      style="margin-bottom: 0; padding-bottom: 0"
    >
      <!-- Col: Left (pdf Container) -->
      <b-col
        class="pdf-add"
        cols="12"
        style="margin-bottom: 0; padding-bottom: 0"
      >
        <b-card no-body class="pdf-preview-card">
          <!-- Header -->
          <div
            class="pdf_header pdf-padding pt-2"
            style="margin-bottom: 0; padding-bottom: 0"
          >
            <div class="logo">
              <img class="d-block mx-auto" :src="info.logo_url" />
              <h2 class="mx-auto d-table mt-1">報價單 Quotation</h2>
            </div>

            <div class="license color0">
              <div class="license-content" v-html="info.company_info"></div>
              <!-- <div>屋宇署註冊小型工程承建商</div>
              <div>MWC3649/2011</div>
              <div>機電工程署電業承辦商</div>
              <div>026812</div> -->
            </div>
            <div class="pdf-form">
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title"> 客戶： </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.name_cn }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="5" class="text-right title">
                      報價編號：
                    </b-col>
                    <b-col cols="7" class="text">
                      <div class="form-value pdf-number colorRed">
                        {{ pdfData.quotation_number }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      工程地址：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.address }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="5" class="text-right title">
                      發單日期：
                    </b-col>
                    <b-col cols="7" class="text">
                      <div class="form-value">
                        {{ pdfData.quotation_date }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item mb-1">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      聯絡電話：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.mobile }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <!-- Spacer -->
          <div
            class="pdf-padding form-item-section"
            style="padding-top: 0; padding-bottom: 0; margin-bottom: 0"
          >
            <!-- :style="{ height: controlValue.minHeight - 1 + 'cm' }" -->
            <div class="pdf-table" style="height: 540px">
              <div class="line a"></div>
              <div class="line b"></div>
              <div class="line c"></div>
              <div class="line d"></div>
              <!-- <div class="line e"></div> -->
              <div class="d-flex">
                <div class="thead-label">NO.</div>
                <div class="thead-label">摘要 Description</div>
                <div class="thead-label">數量</div>
                <!-- <div class="thead-label">尺寸</div> -->
                <div class="thead-label">單價 Cost</div>
                <div class="thead-label">金額(HK$)</div>
              </div>
              <div
                v-for="(item, index) in page"
                :key="index"
                ref="row"
                class="d-flex pdf-item"
              >
                <div class="pdf-item-text-wrapper">
                  <span
                    class="pdf-item-text"
                    v-if="item.amount >= 0 && !item.is_remark"
                    >{{ item.count }}</span
                  >
                </div>

                <div class="pdf-item-text-wrapper">
                  <span
                    class="pdf-item-text"
                    v-html="changeNextLine(item.item_description)"
                  ></span>
                </div>
                <div class="pdf-item-text-wrapper">
                  <div
                    v-if="item.amount >= 0 && !item.is_remark"
                    class="pdf-item-text d-flex justify-content-around"
                  >
                    <span>{{
                      parseFloat(Number(item.quantity).toString())
                    }}</span>
                    <span style="width: 20px">{{
                      item.product && item.product.product_unit
                        ? item.product.product_unit.name
                        : "次"
                    }}</span>
                  </div>
                </div>
                <!-- <div class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">{{
                    item.product && item.product.size
                  }}</span>
                </div> -->
                <div class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">HK${{
                    formatMoney(item.unit_price || 0)
                  }}</span>
                </div>
                <div class="pdf-item-text-wrapper">
                  <span
                    class="pdf-item-text text-right"
                    >HK${{ formatMoney(item.amount || 0) }}</span
                  >
                </div>
              </div>
            </div>

            <div class="pdf-table-amount-wrapper">
              <!-- <div class="quotation-table-amount">
                <div></div>
                <span class="total-amount">{{
                  getNumberFormat(pdfData.amount)
                }}</span>
              </div>
              <div class="quotation-table-amount">
                <div></div>
                <span class="total-amount">{{
                  getNumberFormat(Number(pdfData.coupon_discount))
                }}</span>
              </div>
              <div class="quotation-table-amount">
                <div></div>
                <span class="total-amount">{{
                  getNumberFormat(Number(pdfData.gift_voucher_discount))
                }}</span>
              </div> -->
              <div
                class="pdf-table-amount"
                :class="{ 'not-finish': pageIndex < pages.length - 1 }"
              >
                <div></div>
                <span
                  v-if="pageIndex == pages.length - 1"
                  class="total-amount"
                  >{{ getNumberFormat(pdfData.total_amount) }}</span
                >
                <span v-else class="total-amount">轉下頁</span>
              </div>
            </div>
          </div>
          <!-- Footer & Payment Detail -->
          <div class="pdf-padding pdf-footer">
            <div class="pdf-form sign">
              <div class="d-flex w-100 form-item mb-4">
                <div class="box">
                  <div class="text-left title">
                    <div>
                      <span class="sign-text">客戶蓋章或簽署：</span>
                    </div>
                  </div>
                  <div class="text">
                    <!-- <div class="form-value"></div> -->
                  </div>
                </div>
                <div class="box">
                  <div class="text-left title">
                    <div>
                      <div class="sign-text">永發設計工程有限公司</div>
                      <div class="sign-text">公司簽署或蓋章：</div>
                    </div>
                  </div>
                  <div class="text">
                    <img v-if="info.stamp_url" class="stamp_logo" :src="info.stamp_url" alt="" />
                    <!-- <div class="form-value"></div> -->
                  </div>
                </div>
              </div>

              <div class="d-flex form-item">
                <div class="box">
                  <div class="d-flex">
                    <div class="title" style="font-size: 11px">簽署日期：</div>
                    <div class="text">
                      <div class="form-value"></div>
                    </div>
                  </div>
                </div>
                <div class="box">
                  <div class="d-flex">
                    <div class="title" style="font-size: 11px">簽署日期：</div>
                    <div class="text">
                      <div class="form-value">
                        <template v-if="info.stamp_url">{{
                          controlValue.sign_date
                        }}</template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-left remark">
                <label class="colorBlack" style="font-size: 11px">備註:</label>
                <pre class="" v-html="pdfData.quotation_remark"></pre>
                <!-- <ol class="pl-1">
                  <li>
                    報價單有效期由發單日計30天有效，所有價格或尺寸將以工程合約作最終計算，倘有錯漏，祈為指証。
                  </li>
                  <li>
                    工程地點只包括有電梯到達運送，如遇上搬運物料困難，
                    將另收搬運費用。(合約聲明除外)
                  </li>
                  <li>
                    傢俬訂造來訂50%,
                    合約工程首期來訂50%。收訂作實後將另發收據及發票(或銷售合約)。餘額貨款將依合約的階段分段收取。
                  </li>
                  <li>
                    報價單內呎吋只供參考，價格將以工程地點施工範圍作準。傢俬訂造不包括任何型式收口或完工後清潔。(合約聲明除外)
                  </li>
                  <li>
                    支票抬頭人請註明『 永發設計工程有限公司 』或『 WING FAT
                    DESIGN CONTRACTING LTD 』({{ info.bank_info }})
                  </li>
                </ol> -->
              </div>
              <hr class="w-100" />
              <div class="d-flex company-info flex-wrap mb-0">
                <div class="w-50">
                  <div class="d-flex">
                    <span>地址：</span>
                    <span>{{ info.address }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>網址：</span>
                    <span>{{ info.website }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電話：</span>
                    <span>{{ info.phone }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電郵：</span>
                    <span>{{ info.email }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>傳真：</span>
                    <span>{{ info.fax }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pdf-bottom">
            {{ `P.${pageIndex + 1}/${pages.length}` }}
          </div>
        </b-card>
      </b-col>
      <!-- <b-col cols="12">
        <NoticeToCustomers />
      </b-col> -->
    </b-row>
  </section>
</template>
<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";

import { mapFields } from "vuex-map-fields";
import { formatMoney } from "@/libs/helper.js";
import NoticeToCustomers from "@/views/invoice/invoices-preview/NoticeToCustomers.vue";
import { ref, watch } from "@vue/composition-api";
import { buildPages, measureRowHeight } from "@/libs/pdf-pagination";

// 報價表格的排版尺寸，需與 style.scss 的 .pdf-table / .pdf-item-text-wrapper 一致
const TABLE_BODY_HEIGHT = 500; // 表格 540px 扣邊框及單行表頭（約 37px）
const NO_WIDTH = 40; // NO. 欄
const DESCRIPTION_WIDTH = 342; // 摘要欄 347px 扣 5px padding-left
const QUANTITY_WIDTH = 45; // 數量欄 65px 扣單位 span 20px
const UNIT_WIDTH = 20; // 單位 span 固定 20px，多字單位會換行
const PRICE_WIDTH = 107; // 單價／金額欄 110px 扣 3px padding-right

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
    };
  },
  methods: {
    formatMoney,
    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 2, // 確保總是顯示2位小數
        maximumFractionDigits: 2, // 限制最多2位小數
      });
      return formatter.format(amount);
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === 'string') {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === 'object' && str.content) {
        return typeof str.content === 'string' ? str.content.replace(/\n/g, "<br>") : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === 'object' && str.title) {
        return typeof str.title === 'string' ? str.title.replace(/\n/g, "<br>") : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === 'number' || typeof str === 'boolean') {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str.map(item =>
          typeof item === 'string' ? item :
          (typeof item === 'object' && item.content) ? item.content :
          String(item)
        ).join('<br>');
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== '[object Object]' ? stringValue : "";
      } catch (error) {
        console.warn('changeNextLine: 無法處理的資料類型', str);
        return "";
      }
    },
    splitIntoPages() {
      if (!this.pdfData.cost_items || this.pdfData.cost_items.length === 0) {
        return;
      }

      const rows = this.pdfData.cost_items.map((item, index) => ({
        ...item,
        count: index + 1,
      }));

      // 处理备注
      if (this.pdfData.remark) {
        rows.push(this.buildRemarkRow(this.pdfData.remark));
      }

      this.pages = buildPages({
        rows,
        bodyHeight: TABLE_BODY_HEIGHT,
        descriptionWidth: DESCRIPTION_WIDTH,
        measureRow: this.measureRow,
        getDescription: (row) => this.toPlainText(row.item_description),
        withDescription: (row, text, index) =>
          index === 0
            ? { ...row, item_description: text }
            : { ...row, ...this.buildRemarkRow(text), count: null },
      });

      // 触发更新
      this.$forceUpdate();
    },

    buildRemarkRow(description) {
      return {
        is_remark: true,
        id: null,
        item_description: description,
        quantity: null,
        unit_price: null,
        amount: null,
      };
    },

    // .pdf-item 係 flex 列，高度由最高嗰個欄位決定，唔可以淨係計摘要欄。
    // 單價同金額喺報價單冇 v-if，備註列一樣會 render，所以照計。
    measureRow(row) {
      const isRemark = !!row.is_remark;
      const showsQuantity = !isRemark && Number(row.amount) >= 0;

      const cells = [
        {
          html: this.changeNextLine(row.item_description),
          width: DESCRIPTION_WIDTH,
        },
        {
          html: `HK$${this.formatMoney(row.unit_price || 0)}`,
          width: PRICE_WIDTH,
        },
        {
          html: `HK$${this.formatMoney(row.amount || 0)}`,
          width: PRICE_WIDTH,
        },
      ];

      if (showsQuantity) {
        cells.push({ html: String(row.count), width: NO_WIDTH });
        cells.push({
          html: String(parseFloat(Number(row.quantity).toString())),
          width: QUANTITY_WIDTH,
        });
        cells.push({ html: this.getUnitName(row), width: UNIT_WIDTH });
      }

      return measureRowHeight(cells);
    },

    getUnitName(row) {
      return row.product && row.product.product_unit
        ? row.product.product_unit.name
        : "次";
    },

    // changeNextLine 已處理各種資料型別，呢度只係反轉返 <br> 做純文字方便切割。
    toPlainText(description) {
      const html = this.changeNextLine(description);
      return html ? html.replace(/<br\s*\/?>/gi, "\n") : "";
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    NoticeToCustomers,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },
    productUnitOptions: {
      type: Array,
      required: true,
    },
  },
  watch: {
    "pdfData.cost_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  computed: {
    ...mapFields(["controlValue"]),
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);

      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);
      if (template) {
        info.value.website = template.website;
        info.value.address = template.address;
        info.value.phone = template.phone;
        info.value.fax = template.fax;
        info.value.email = template.email;
        info.value.company_info = template.company_info;
        info.value.bank_info = template.bank_info;
        info.value.logo_url = template.logo_url;
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };

    var init = true;

    watch(
      () => props.pdfData,
      (newVal, oldVal) => {
        if (newVal && newVal.template_id && init) {
          getInfo(newVal.template_id, newVal.stamp_id);
          init = false;
        }
      }
    );

    return {
      info,
      getInfo,
    };
  },
};
</script>

<style lang="scss" scoped>
// pdf
.remark {
  height: 97px;
  pre {
    font-size: 10.5px;
  }
}


.stamp_logo {
  top: 10px;
  right: -65px;
}
</style>
